/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * @param {FormReducerDraftState} state 
 * @param {FormReducerAction} action 
 */
export function StepReducerActions (state, action) {
    const { type } = action;

    switch (type) {

        case "step/add": {
            const steps = state.form.steps;

            /** @type {Step} */
            const step = {
                step: steps.length + 1,
                label: ""
            };

            state.form.steps.push(step);
            break;
        }

        case "step/update": {
            const { label, stepNumber } = action;

            const step = state.form.steps.find(
                (step) => step.step === stepNumber
            );

            step.label = label;
            break;
        }

        case "step/remove": {
            const { deleteStep } = action;

            // remove the step
            state.form.steps = state.form.steps.filter(
                (step) => step.step !== deleteStep
            );

            // shift question steps down one
            for (const question of state.form.questions) {
                if (question.step >= deleteStep) {
                    // ensure that the step can't be moved to anything below 1
                    const newStep = Math.max(question.step - 1, 1);
                    question.step = newStep;
                }
            }

            break;
        }

        default:
            return false;

    }

    return state;
}
